module.exports = "<banner-message></banner-message>\n<app-header ></app-header>\n<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <navbar class=\"main-content__nav\"></navbar>\n      <article class=\"main-content\" ui-view></article>\n    </div>\n    <div class=\"col-sm-12\">\n      <app-footer></app-footer>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./app/app.html
// module id = 161
// module chunks = 1